import type { Quantity } from "@@/shared/units-and-quantities/quantity";
import type { BookableOptionValueId } from "./bookable-option-value-id";
import {
    isManifestBookableOptionValue,
    type ManifestBookableOptionValue,
} from "./manifest-bookable-option-value";
import {
    isQuantityPickerBookableOptionValue,
    type QuantityPickerBookableOptionValue,
} from "./quantity-picker-bookable-option-value";

type BookableOptionValue =
    | QuantityPickerBookableOptionValue
    | ManifestBookableOptionValue;
type BookableOptionValueType = BookableOptionValue["_type"];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isBookableOptionValue = (item: any): item is BookableOptionValue => {
    return (
        isQuantityPickerBookableOptionValue(item) ||
        isManifestBookableOptionValue(item)
    );
};

const isBookableOptionValueWithQuantity = (
    item:
        | {
              _id: BookableOptionValueId;
              _type: unknown;
          }
        | undefined,
): item is BookableOptionValue & { quantity: Quantity } => {
    if (typeof item === "undefined") return false;
    const hasQuantity = isQuantityPickerBookableOptionValue(item);
    return hasQuantity;
};

export { isBookableOptionValue, isBookableOptionValueWithQuantity };
export type { BookableOptionValue, BookableOptionValueType };
